import { ETooltipVariant, GeneralHowToIcon, Tooltip } from '@outdoorsyco/bonfire';
import React from 'react';

interface IHelpProps {
  /**
   * The content displayed within the Tooltip
   */
  content: string;
  className?: string;
}

const Help: React.FC<IHelpProps> = ({ content, className }) => {
  return (
    <Tooltip
      content={content}
      className={className}
      variant={ETooltipVariant.Dark}
      arrow={false}
      placement="bottom-start">
      <div className="inline-flex items-center justify-center w-5 h-5 border-none rounded-full text-gray-850 bg-canvas-200 hover:bg-gray-850 hover:text-white group-focus:bg-primary-900 group-focus:text-primary-contrast">
        <GeneralHowToIcon fontSize={20} />
      </div>
    </Tooltip>
  );
};

export default Help;
